const DotsSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 5C8.55228 5 9 4.55228 9 4C9 3.44772 8.55228 3 8 3C7.44772 3 7 3.44772 7 4C7 4.55228 7.44772 5 8 5Z" fill="#333333" />
      <path d="M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z" fill="#333333" />
      <path
        d="M8 12.667C8.55228 12.667 9 12.2193 9 11.667C9 11.1147 8.55228 10.667 8 10.667C7.44772 10.667 7 11.1147 7 11.667C7 12.2193 7.44772 12.667 8 12.667Z"
        fill="#333333"
      />
    </svg>
  );
};

export default DotsSvg;
